import PlanejamentoAcaoFormCampos from '../../../produto/spa/planejamento-acao/form/PlanejamentoAcaoFormCampos';

export default PlanejamentoAcaoFormCampos;
